<template>
    <section class="product">
        <div class="product__container container">
            <div class="product__slider">
                <div class="product__head">
                    <h1 class="product__title">{{ product?.name }}</h1>
                    <div v-if="product?.code" class="product__code">
                        {{ $t('productCode') }} <span>{{ product?.code }}</span>
                    </div>
                </div>
                <ScreenSlider :isPreloader="isPreloader" :slides="slides" :badges="badges" />
                <Slider :isPreloader="isPreloader" :slides="slides" :badges="badges" />
            </div>
            <div class="product__board">
                <PanelBoard
                    :product="product"
                    :pocketProducts="pocketProducts"
                    :isPreloader="isPreloader"
                    @set-param="setParam($event)"
                    @set-service="$emit('set-service', $event)"
                    @set-extension-direction="$emit('set-extension-direction', $event)"
                    @set-active-extensions="$emit('set-active-extensions', $event)"
                    @open-modal-content="$emit('open-modal-content', $event)"
                    @open-pocket-products="$emit('open-pocket-products', $event)"
                />
            </div>
        </div>
        <transition name="fade">
            <div v-if="isPreloaderCurtain" class="product__preloader-curtain">
                <MyCirclePreloader :strokeWidth="2" :size="24" />
            </div>
        </transition>
    </section>
</template>

<script>
import VueTypes, { nullable } from 'vue-types';
import { Product, SliderItem, PocketProductItem } from './../../types';

import ScreenSlider from './components/ScreenSlider';
import Slider from './components/Slider';
import PanelBoard from './components/PanelBoard';
import MyActionBtn from '@/themes/novaporta/components/ui/MyActionBtn';
import MyCirclePreloader from '@/themes/novaporta/components/ui/MyCirclePreloader';

export default {
    name: 'Product',
    props: {
        isPreloader: VueTypes.bool.isRequired,
        isPreloaderCurtain: VueTypes.bool.isRequired,
        pocketProducts: VueTypes.arrayOf(PocketProductItem).def([]),
        product: VueTypes.oneOfType([Product, nullable]).def(null),
        slides: VueTypes.arrayOf(SliderItem).def([])
    },
    computed: {
        badges() {
            return this.product?.badges || [];
        }
    },
    watch: {
        isPreloaderCurtain(newVal) {
            document.body.classList[newVal ? 'add' : 'remove']('--hidden');
        }
    },
    components: {
        ScreenSlider,
        Slider,
        PanelBoard,
        MyActionBtn,
        MyCirclePreloader
    },
    methods: {
        setParam(slug) {
            this.$emit('set-param', slug);
        }
    }
};
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
